import { api } from "../../api/fetch";
import { TestSuite } from '../entity';

export const archiveTestSuite = async (testSuite: TestSuite) => {
    return  await api.put(`/api/v1/test-suites/${testSuite.id}/archive`);
}

export default archiveTestSuite;
